"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nftStoryMapping = exports.NFTStory = void 0;
var NFTStory;
(function (NFTStory) {
    NFTStory["FEZ_LOVE"] = "Fez Love";
})(NFTStory = exports.NFTStory || (exports.NFTStory = {}));
exports.nftStoryMapping = {
    [NFTStory.FEZ_LOVE]: {
        authorAddress: '0x9f7a9c6679193aabed7f0af4069485b32a1ff251',
        storyId: '2',
    }
};
//# sourceMappingURL=nftStoryMapping.js.map